import { ButtonNames } from '../components/button/button.constants';
import { ModalData } from '../models/modal-data';
import { SuccessMessage, ErrorMessage } from '@app/constants/messages.constants';

export enum ModalConfig {
  AutoHeight = 'auto',
  StandardHeight = '150px',
  BiggerHeight = '500px',
  StandardWidth = '600px',
  SmallerWidth = '400px',
  EligibilityWidth = '500px',

  Submit = 'submit',
  SubmitTimesheetText = 'Do you want to Save & Submit the Timesheet',

  Eligibility = 'eligibility',
  EligibilityTimesheetText = 'Modify Eligibility for',

  ChangeAccess = 'change access',
  ChangeAccessText = 'Do you want to set Access Level for',

  Recall = 'recall',
  RecallText = 'Do you want to Recall the Timesheet',

  Layout = 'Layout',
  LayoutText = 'Layout Settings',

  Reopen = 'reopen',
  ReopenTimesheetText = 'Do you want to Reopen timesheet of',

  CustomDeadline = 'custom deadline',
  CustomDeadlineText = 'Do you want to save the Custom Deadline ',

  CustomNotifications = 'custom notifications',
  CustomNotificationsText = 'Do you want to save the Custom Notifications ',

  EmptyDefaultNotifications = 'empty default notifications',
  EmptyDefaultNotificationsText = 'Are you sure you want to remove all Default Notifications starting from',

  EmptyCustomNotifications = 'empty custom notifications',

  NotificationsWithoutMessage = 'notifications without message',
  NotificationsWithoutMessageText = 'The subject and content of notification emails cannot be empty.',

  NotificationsWithoutNotifications = 'notifications without notifications',
  NotificationsWithoutNotificationsText = 'You should add at least one notification if subject or message is filled',

  Validation = 'validation',
  ValidationText = 'Please fix errors highlighted in red',

  UnsavedTimesheet = 'unsaved timesheet',
  UnsavedTimesheetText = 'Do you want to save the Timesheet data ',
  UnsavedTimesheetDetails = 'Changes you made may not be saved.'
}

export const BASIC_SUBMIT_MODAL_DATA: Partial<ModalData> = {
  name: ModalConfig.Submit,
  text: ModalConfig.SubmitTimesheetText,
  hasDate: true,
  approveText: ButtonNames.Yes,
  cancelText: ButtonNames.No,
  successMessage: SuccessMessage.SubmitTimeshet,
  errorMessage: ErrorMessage.General
};

export const BASIC_ACCESS_MODAL_DATA: Partial<ModalData> = {
  name: ModalConfig.ChangeAccess,
  text: ModalConfig.ChangeAccessText,
  approveText: ButtonNames.Yes,
  cancelText: ButtonNames.No,
  successMessage: SuccessMessage.ChangeAccess,
  errorMessage: ErrorMessage.General
};

export const BASIC_RECALL_MODAL_DATA: Partial<ModalData> = {
  name: ModalConfig.Recall,
  text: ModalConfig.RecallText,
  hasDate: true,
  approveText: ButtonNames.Yes,
  cancelText: ButtonNames.No,
  successMessage: SuccessMessage.RecallTimesheet,
  errorMessage: ErrorMessage.General
};

export const BASIC_CHANGE_LAYOUT_MODAL_DATA: Partial<ModalData> = {
  name: ModalConfig.Layout,
  text: ModalConfig.LayoutText,
  approveText: ButtonNames.Save,
  cancelText: ButtonNames.DiscardChanges,
  successMessage: SuccessMessage.ChangeLayout,
  errorMessage: ErrorMessage.General
};

export const BASIC_REOPEN_MODAL_DATA: Partial<ModalData> = {
  name: ModalConfig.Reopen,
  text: ModalConfig.ReopenTimesheetText,
  hasDate: true,
  approveText: ButtonNames.Yes,
  cancelText: ButtonNames.No,
  successMessage: SuccessMessage.ReopenTimesheet,
  errorMessage: ErrorMessage.General
};

export const BASIC_ELIGIBILITY_MODAL_DATA: Partial<ModalData> = {
  name: ModalConfig.Eligibility,
  text: ModalConfig.EligibilityTimesheetText,
  approveText: ButtonNames.Save,
  cancelText: ButtonNames.DiscardChanges,
  successMessage: SuccessMessage.ChangeEligibility,
  errorMessage: ErrorMessage.General
};

export const SUBMIT_CUSTOM_DEADLINE_MODAL_DATA: Partial<ModalData> = {
  name: ModalConfig.CustomDeadline,
  text: ModalConfig.CustomDeadlineText,
  approveText: ButtonNames.Yes,
  cancelText: ButtonNames.No,
  hasSelectedMonth: true,
  successMessage: SuccessMessage.ChangeCustomDeadline,
  errorMessage: ErrorMessage.PostCustomDeadlineData
};

export const SUBMIT_CUSTOM_NOTIFICATIONS_MODAL_DATA: Partial<ModalData> = {
  name: ModalConfig.CustomNotifications,
  text: ModalConfig.CustomNotificationsText,
  approveText: ButtonNames.Yes,
  cancelText: ButtonNames.No,
  hasSelectedMonth: true,
  successMessage: SuccessMessage.ChangeCustomNotifications,
  errorMessage: ErrorMessage.PostCustomNotificationsData
};

export const SUBMIT_EMPTY_NOTIFICATIONS: Partial<ModalData> = {
  name: ModalConfig.CustomNotifications,
  approveText: ButtonNames.Ok,
  successMessage: SuccessMessage.ChangeCustomNotifications,
  errorMessage: ErrorMessage.General
};

export const BASIC_VALIDATION_MODAL_DATA: Partial<ModalData> = {
  name: ModalConfig.Validation,
  text: ModalConfig.ValidationText,
  approveText: ButtonNames.Ok
};

export const NOTIFICATIONS_WITHOUT_MESSAGE_MODAL_DATA: Partial<ModalData> = {
  name: ModalConfig.NotificationsWithoutMessage,
  text: ModalConfig.NotificationsWithoutMessageText,
  approveText: ButtonNames.Ok
};

export const NOTIFICATIONS_WITHOUT_NOTIFICATION_MODAL_DATA: Partial<ModalData> = {
  name: ModalConfig.NotificationsWithoutNotifications,
  text: ModalConfig.NotificationsWithoutNotificationsText,
  approveText: ButtonNames.Ok
};

export const EMPTY_DEFAULT_NOTIFICATIONS_DATA: Partial<ModalData> = {
  name: ModalConfig.EmptyDefaultNotifications,
  text: ModalConfig.EmptyDefaultNotificationsText,
  approveText: ButtonNames.Yes,
  cancelText: ButtonNames.No,
  successMessage: SuccessMessage.ChangeDefaultNotifications
};

export const UNSAVED_TIMESHEET: Partial<ModalData> = {
  name: ModalConfig.UnsavedTimesheet,
  text: ModalConfig.UnsavedTimesheetText,
  details: ModalConfig.UnsavedTimesheetDetails,
  approveText: ButtonNames.Yes,
  cancelText: ButtonNames.No,
  hasDate: true
};
